var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.556 13L0.343 7.39V6.642H0.717C1.31767 6.642 1.822 6.58533 2.23 6.472C2.64933 6.35867 2.978 6.17167 3.216 5.911C3.454 5.65033 3.59567 5.29333 3.641 4.84H0.343V3.752H3.624C3.54467 3.33267 3.386 2.99267 3.148 2.732C2.91 2.46 2.587 2.26167 2.179 2.137C1.78233 2.01233 1.295 1.95 0.717 1.95H0.343V0.861999H7.381V1.95H4.168C4.42867 2.16533 4.644 2.42033 4.814 2.715C4.984 3.00967 5.09167 3.35533 5.137 3.752H7.381V4.84H5.171C5.09167 5.66733 4.77433 6.31333 4.219 6.778C3.675 7.23133 2.94967 7.52033 2.043 7.645L5.29 13H3.556Z",
    fill: "#00C838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/Rupee.ff6667a92eecf364ac2915aebeb6e277.svg";
export { ForwardRef as ReactComponent };